export default __webpack_public_path__ + "static/og-img-1.5M-action-against-hunger-e1e702b0620d2ba82dd65f92c189aea6.png";